namespace PaperTrail.NewsletterControl {
    export interface PageTemplateSectionRow {
        PageTemplateSectionId?: number;
        PageTemplateId?: number;
        Identifier?: string;
        CharactersLimit?: number;
        Height?: number;
        Width?: number;
        Rows?: number;
        Columns?: number;
        Rank?: number;
        DoPageBreak?: boolean;
        StyleSheetId?: number;
        IsFilled?: boolean;
        PageTemplateTitle?: string;
        PageTemplateFileName?: string;
        PageTemplateRank?: number;
        PageTemplateAdsSpots?: number;
        PageTemplateNewsSpots?: number;
        PageTemplateIsFilled?: boolean;
        StyleSheetTitle?: string;
        StyleSheetFont?: string;
        StyleSheetFontSize?: number;
        StyleSheetTextAlignment?: string;
        StyleSheetHeight?: number;
        StyleSheetWidth?: number;
        StyleSheetPadding?: string;
        StyleSheetMargin?: string;
        StyleSheetRows?: number;
        StyleSheetColumns?: string;
        StyleSheetRotation?: number;
        StyleSheetBackgroundColor?: string;
        StyleSheetForeColor?: string;
        StyleSheetIsUnderline?: boolean;
        StyleSheetIsBold?: boolean;
        StyleSheetIsItalic?: boolean;
    }

    export namespace PageTemplateSectionRow {
        export const idProperty = 'PageTemplateSectionId';
        export const nameProperty = 'Identifier';
        export const localTextPrefix = 'NewsletterControl.PageTemplateSection';
        export const lookupKey = 'NewsletterControl.PageTemplateSection';

        export function getLookup(): Q.Lookup<PageTemplateSectionRow> {
            return Q.getLookup<PageTemplateSectionRow>('NewsletterControl.PageTemplateSection');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Newsletter:Contributor';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            PageTemplateSectionId = "PageTemplateSectionId",
            PageTemplateId = "PageTemplateId",
            Identifier = "Identifier",
            CharactersLimit = "CharactersLimit",
            Height = "Height",
            Width = "Width",
            Rows = "Rows",
            Columns = "Columns",
            Rank = "Rank",
            DoPageBreak = "DoPageBreak",
            StyleSheetId = "StyleSheetId",
            IsFilled = "IsFilled",
            PageTemplateTitle = "PageTemplateTitle",
            PageTemplateFileName = "PageTemplateFileName",
            PageTemplateRank = "PageTemplateRank",
            PageTemplateAdsSpots = "PageTemplateAdsSpots",
            PageTemplateNewsSpots = "PageTemplateNewsSpots",
            PageTemplateIsFilled = "PageTemplateIsFilled",
            StyleSheetTitle = "StyleSheetTitle",
            StyleSheetFont = "StyleSheetFont",
            StyleSheetFontSize = "StyleSheetFontSize",
            StyleSheetTextAlignment = "StyleSheetTextAlignment",
            StyleSheetHeight = "StyleSheetHeight",
            StyleSheetWidth = "StyleSheetWidth",
            StyleSheetPadding = "StyleSheetPadding",
            StyleSheetMargin = "StyleSheetMargin",
            StyleSheetRows = "StyleSheetRows",
            StyleSheetColumns = "StyleSheetColumns",
            StyleSheetRotation = "StyleSheetRotation",
            StyleSheetBackgroundColor = "StyleSheetBackgroundColor",
            StyleSheetForeColor = "StyleSheetForeColor",
            StyleSheetIsUnderline = "StyleSheetIsUnderline",
            StyleSheetIsBold = "StyleSheetIsBold",
            StyleSheetIsItalic = "StyleSheetIsItalic"
        }
    }
}
